
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.006","stroke":"#FFA014","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.785 6.292c0 .53-.02 1.024-.059 1.482-.039.458-.091.923-.157 1.394H7.45a36.614 36.614 0 01-.167-1.394c-.039-.458-.059-.952-.059-1.482V4.535h1.561v1.757zm.128 4.27c0 .288-.095.51-.285.668a.938.938 0 01-.628.235.975.975 0 01-.638-.235c-.183-.157-.275-.38-.275-.668 0-.288.092-.51.275-.667A.975.975 0 018 9.659c.235 0 .445.079.628.236.19.157.285.38.285.667z","fill":"#FFA014"}})])
          )
        }
      }
    